---
title: Rainbow Trout Guide
description: Rainbow trout basics and what to log.
---

# Rainbow Trout Guide

Rainbow trout are sensitive to conditions.

Log:
- Flow rate
- Temperature
- Light levels

They reward careful observation.

For comparisons and logging tips, see the full
[species guides](/learn/species).

---
### Keep learning
- [Fishing techniques](/learn/techniques)
- [Species guides](/learn/species)
- [Fishing regions](/learn/regions)
- [Roddo Learn hub](/learn)
